import styled from 'styled-components';
import tw from 'twin.macro';
import MutualAgreementSigns from '../mutualAgreementSigns';

const ArbitrateContainer = styled.div`
  ${tw`border border-gray-300 p-4 pb-0 mb-2 border-solid`}
`;

const Title = styled.div`
  ${tw`font-bold text-sm mb-3`}
`;

const Description = styled.div`
  ${tw`text-sm`}
`;

const SignatureSection = styled.div`
  ${tw`flex flex-row gap-2 pb-2`}
`;

const SignatureRow = styled.div`
  ${tw`mb-2 mt-6`}
`;

const Label = styled.span`
  ${tw`text-sm`}
`;

const Input = styled.input`
  ${tw`border-r-0 border-l-0 border-t-0 border-b-2 border-gray-600 h-[44px]`}
`;

const ArbitrateSection = () => {
  return (
    <ArbitrateContainer>
      <Title>Agreement to Arbitrate:</Title>

      <Description>
        By signing below, you agree that, pursuant to the Arbitration Provision on the reverse side
        of this contract, you or we may elect to resolve any dispute by neutral, binding arbitration
        and not by a court action. See the Arbitration Provision for additional information
        concerning the agreement to arbitrate.
      </Description>

      <SignatureSection>
        <SignatureRow>
          <Label>Buyer Signs X</Label>
        </SignatureRow>
        <SignatureRow>
          <Input type="text" />
        </SignatureRow>

        <SignatureRow>
          <Label>Co-Buyer Signs X</Label>
        </SignatureRow>
        <SignatureRow>
          <Input type="text" />
        </SignatureRow>
      </SignatureSection>
    </ArbitrateContainer>
  );
};

export default ArbitrateSection;
